import log from 'loglevel';
import { isDev } from 'util/environment';

if (isDev()) log.enableAll();

export default log;
